export default __webpack_public_path__ + "static/media/english-to-italian-logo.8a8f31d3.png";